// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:54:26.983Z
// Property: Oak Wood Apartments (ID: 6767906449167361)
// Collections: 19 amenities, 4 floorplans (live), 4 photos, 34 POIs, 1 reviews, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167361",
  "property_external_id": "5098667",
  "property_zillow_url": "https://www.zillow.com/apartments/mansfield-oh/oak-wood-apartments/5gKm8N/",
  "property_apartments_url": "https://www.apartments.com/335-castor-rd-lexington-oh/h82vgp2/",
  "property_google_business_url": "https://www.google.com/maps/place/Oak+Wood+Apartments/data=!4m2!3m1!1s0x0:0x80a22ad7d0ba46b7?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "58522480544",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5098667",
  "property_status": null,
  "property_slug": "oak-wood-apartments",
  "property_name": "Oak Wood Apartments",
  "property_website_url": "https://www.oakwoodapartmentsliving.com/",
  "property_domain": "https://www.oakwoodapartmentsliving.com/",
  "property_address": "335 Castor Rd",
  "property_full_address": "335 Castor Rd, Lexington, OH 44904",
  "property_address_1": "335 Castor Rd",
  "property_address_2": null,
  "property_address_city": "Lexington",
  "property_address_state": "OH",
  "property_address_zip_full": "44904-9325",
  "property_address_zip": "44904",
  "property_address_country": "US",
  "property_address_county": "Richland County",
  "property_neighborhood_address": "Lexington",
  "property_address_latitude": "40.675245",
  "property_address_longitude": "-82.5701615",
  "property_email": "owa@dietzpropertygroup.com",
  "property_phone": "(419) 884-2484",
  "property_call_tracking_phone": "419-884-2484",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Oak Wood Apartments in Lexington, OH, where comfort meets convenience! Choose from spacious two and three-bedroom floor plans, complete with modern amenities like central air, high-speed internet, and pet-friendly spaces. Our on-site management and 24-hour emergency maintenance ensure a worry-free lifestyle. Begin your new chapter today!",
  "property_long_description": "**Welcome to Oak Wood Apartments – Your New Home Awaits in Lexington, OH!**\n\nDiscover the perfect blend of comfort and convenience at Oak Wood Apartments, where we offer spacious two and three-bedroom floor plans designed to accommodate your lifestyle. Our community is ideal for families, professionals, and pet lovers alike, providing a welcoming environment that feels like home the moment you step inside.\n\nNestled in a prime location, Oak Wood Apartments features controlled access for your peace of mind, along with an on-site management team dedicated to ensuring your needs are met. Enjoy the convenience of 24-hour emergency maintenance and online payment options, making life just a little easier. Your furry friends are welcome here too, thanks to our pet-friendly policy!\n\nExperience a range of amenities designed for your comfort, including central heat and air conditioning, a fully equipped kitchen with a stove, refrigerator, dishwasher, and garbage disposal, as well as spacious closets to keep your belongings organized. Step outside to relax on your private balcony or patio, or visit our playground for family fun.\n\nWith high-speed internet access, and an on-site laundry facility, you’ll have everything you need right at your fingertips. Our ideal location ensures that you’re just minutes away from shopping, dining, and entertainment options, making Oak Wood Apartments the perfect place to call home.\n\nDon’t wait – find your new home today at Oak Wood Apartments! Browse our availability or schedule a tour to explore our community and discover why so many love living here. Your new beginning is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dd018-bcd8-74fb-abab-d7ba567d9fba.webp",
  "property_featured_image_media": {
    "alt_text": "Oak Wood Apartments monument sign with a brick building and trees in the background.",
    "public_id": "019dd018-bcd8-74fb-abab-d7ba567d9fba",
    "storage_key": "property/6767906449167361/019dd018-bcd8-74fb-abab-d7ba567d9fba.webp",
    "width": 1191,
    "height": 794
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "84",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.04761904761905",
  "property_admin_fee": "150",
  "property_application_fee": "25",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "Oak Wood Apartments is a pet friendly community. We proudly accept up to 2 pets per apartment home. There is a non‑refundable pet fee of $200 per pet and a monthly pet rent of $35 per pet. Breed restrictions apply.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dogs\nPet Monthly Rent Min/Max: $35 - $70\nPet Policy: Oak Wood Apartments is a pet friendly community. We proudly accept up to 2 pets per apartment home. There is a non-refundable pet fee of $200 per pet and a monthly pet rent of $35 per pet. Please contact our Leasing Office for our full pet policy. Breed restrictions apply.\nPet Rent Basis: Per Pet\nMax Number of Pets: 2\nPet Policy Fee Min/Max: $200 - $400",
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b6-3561-7226-a639-9997fae3fb45.webp",
  "property_primary_logo_media": {
    "alt_text": "Oak Wood Apartments logo",
    "public_id": "019d63b6-3561-7226-a639-9997fae3fb45",
    "storage_key": "property/6767906449167361/019d63b6-3561-7226-a639-9997fae3fb45.webp",
    "width": 600,
    "height": 243
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dd019-89c1-70c1-b689-834bc89db7b1.webp",
  "property_secondary_logo_media": {
    "alt_text": "Generic 'O' icon",
    "public_id": "019dd019-89c1-70c1-b689-834bc89db7b1",
    "storage_key": "property/6767906449167361/019dd019-89c1-70c1-b689-834bc89db7b1.webp",
    "width": 24,
    "height": 28
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b6-d511-7568-8ccf-2fbf14a4e44c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d63b6-d511-7568-8ccf-2fbf14a4e44c",
    "storage_key": "property/6767906449167361/019d63b6-d511-7568-8ccf-2fbf14a4e44c.webp",
    "width": 600,
    "height": 243
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b6-9905-754c-8fff-7234e5872eb6.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d63b6-9905-754c-8fff-7234e5872eb6",
    "storage_key": "property/6767906449167361/019d63b6-9905-754c-8fff-7234e5872eb6.webp",
    "width": 600,
    "height": 243
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#0AB38A",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "851 - 1001",
  "property_sqft_min": "851",
  "property_sqft_max": "1001",
  "property_price_range": "826 - 1099",
  "property_price_min": "826",
  "property_price_max": "1099",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/pages/oak-wood-apartments/125269827528273",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJn4UAeHm_OYgRt0a60NcqooA",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/oak-wood-apartments-lexington",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Oak Wood Apartments",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "Welcome to Oak Wood Apartments in Lexington, OH, where comfort meets convenience. Choose from our spacious two and three-bedroom floor plans, designed for modern living. Enjoy a pet-friendly community with 24-hour emergency maintenance, on-site management, and generous amenities including a playground, high-speed internet, and more. Embrace your new lifestyle today!",
  "property_home_floorplans_blurb": "At Oak Wood Apartments in Lexington, OH, spacious living awaits you with our thoughtfully designed two and three-bedroom floor plans. Each layout combines comfort and style, tailored for your unique lifestyle. Browse our available apartment homes today and uncover the ideal space that reflects your vision of home.",
  "property_home_gallery_blurb": "At Oak Wood Apartments in Lexington, OH, life blends comfort and convenience. Choose from spacious two- and three-bedroom floor plans, featuring modern amenities like controlled access and 24-hour maintenance. With pet-friendly policies, a playground, and professional management, picture yourself living here, where every detail feels like home.",
  "property_home_neighborhood_blurb": "Welcome to Oak Wood Apartments, where modern living meets the charm of Lexington, OH. Nestled near serene spots like the Ohio Bird Sanctuary and Kingwood Center Gardens, you’ll enjoy easy access to cultural treasures like the Bellville-Jefferson Township Historical Society Museum and outdoor adventures at Sterkel Park. Come see what awaits!",
  "property_home_reviews_blurb": "At Oak Wood Apartments in Lexington, OH, residents rave about their beautifully remodeled homes and attentive management. One thrilled resident shares, \"*Out of the rentals I’ve been in, this is top of the list.*\" Join our vibrant community and see why so many love calling Oak Wood home!",
  "property_neighborhood_blurb": "Nestled in picturesque Lexington, OH, Oak Wood Apartments offers more than just spacious two and three-bedroom homes. Dive into local culture with nearby historical gems like the Bellville-Jefferson Township Historical Society Museum and the serene Kingwood Center Gardens. Discover a vibrant community where convenience meets charm—your ideal lifestyle awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Elevate your lifestyle at Oak Wood Apartments in Lexington, OH. Choose from spacious two and three-bedroom layouts, complete with modern amenities like central air, high-speed internet, and private balconies. Enjoy our pet-friendly community, on-site management, and 24-hour emergency maintenance. Your perfect home awaits—come see what makes us unique!",
  "property_applynow_blurb": "At Oak Wood Apartments in Lexington, OH, you'll find the perfect blend of comfort and convenience. Choose from spacious two and three-bedroom floor plans, all featuring modern amenities like controlled access and pet-friendly policies. Enjoy on-site management, a playground, and hassle-free online payments. Find your new home and lease online today!",
  "property_contactus_blurb": "At Oak Wood Apartments in Lexington, OH, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Whether you’re entertaining or enjoying a quiet evening, our homes are designed with your lifestyle in mind. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Oak Wood Apartments in Lexington, OH, we offer spacious two and three-bedroom floor plans designed for comfort and style. Have questions? Our FAQs page is the perfect resource to help you navigate your new community. Get the answers you need and start your journey with us today!",
  "property_floorplans_blurb": "At Oak Wood Apartments in Lexington, OH, your ideal living space awaits. Choose from stylish two-bedroom and expansive three-bedroom floor plans designed for comfort and convenience. With a variety of layouts to suit your lifestyle, browse our available apartment homes and find the perfect fit for your next chapter.",
  "property_gallery_blurb": "At Oak Wood Apartments in Lexington, OH, your ideal home awaits! With spacious two and three-bedroom floor plans featuring modern amenities like air conditioning, high-speed internet, and a pet-friendly environment, you'll enjoy comfort and convenience. Picture yourself relaxing on your private balcony or patio! Check out our photo gallery now!",
  "property_interactivemap_blurb": "At Oak Wood Apartments in Lexington, OH, our two and three-bedroom floor plans offer the perfect blend of comfort and convenience. Enjoy controlled access, on-site management, and a pet-friendly community. With high-speed internet and spacious closets, your ideal home awaits—explore our interactive map to find your perfect space!",
  "property_pets_blurb": "At Oak Wood Apartments in Lexington, OH, your furry friends are more than welcome! With spacious homes accommodating up to two pets, you can enjoy the perfect blend of comfort and companionship. Our pet-friendly policy, complete with amenities designed for your beloved companions, makes living here a tail-wagging delight!",
  "property_referafriend_blurb": "At Oak Wood Apartments in Lexington, OH, inviting home awaits you and your friends. Choose from spacious two and three-bedroom floor plans designed for comfort and connection. Share the joy of community living—great friends make great neighbors. Refer a friend today and enjoy the benefits of having them nearby!",
  "property_residentaccess_blurb": "At Oak Wood Apartments in Lexington, OH, your new home awaits with spacious two- and three-bedroom floor plans designed for comfort and style. For our valued residents, access your portal today to manage rent, schedule maintenance, and enjoy seamless living at your fingertips!",
  "property_reviews_blurb": "At Oak Wood Apartments in Lexington, OH, our residents rave about their beautifully remodeled homes. One proud tenant shares, “This is top of the list” among rentals. With transparent lease agreements and considerate maintenance notifications, we strive to make your living experience exceptional. See what our residents have to say!",
  "property_created_at": "1775494329760",
  "property_scheduletour_blurb": "At Oak Wood Apartments in Lexington, OH, our thoughtfully designed two- and three-bedroom floor plans offer spacious comfort for every lifestyle. Schedule a tour today and immerse yourself in our vibrant community—just ask our residents about their exceptional living experience! Your new home awaits amid serene surroundings.",
  "property_thankyou_blurb": "Thank you for sharing your details! At Oak Wood Apartments in Lexington, OH, our spacious two- and three-bedroom floor plans offer the perfect blend of comfort and style. Your dream home awaits—an accommodating space tailored just for you! Our team will be in touch soon to assist you further.",
  "property_virtualtours_blurb": "Experience the charm of Oak Wood Apartments in Lexington, OH, where modern living meets comfort. Choose from spacious two and three-bedroom floor plans tailored to your lifestyle. Ready to see more? Take a virtual tour of our vibrant community and find your perfect home today!",
  "property_copyright": "2026 All Rights Reserved. Oak Wood Apartments",
  "property_seo_title_home": "Oak Wood Apartments |  Apartments in Mansfield, OH",
  "property_seo_description_home": "Embrace modern living at Oak Wood Apartments in Mansfield, OH! Choose from cozy two- or three-bedroom layouts with fantastic amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Mansfield, OH Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Oak Wood Apartments in Mansfield, OH! Choose from spacious two and three-bedroom floor plans tailored to fit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Mansfield, OH Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Oak Wood Apartments in Mansfield, OH. Enjoy pet-friendly living with modern features and amenities. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Mansfield, OH",
  "property_seo_description_gallery": "Experience life at Oak Wood Apartments in Mansfield, OH. Enjoy spacious floor plans, modern amenities, and a community feel. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Oak Wood Apartments Apartments",
  "property_seo_description_virtualtours": "Step into Oak Wood Apartments in Mansfield, OH! Experience spacious two and three-bedroom homes. Take a virtual tour and envision your new lifestyle today!",
  "property_seo_title_interactivemap": "Interactive Map | Oak Wood Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Oak Wood Apartments in Mansfield, OH! Explore spacious 2 & 3-bedroom layouts and vibrant amenities with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mansfield, OH",
  "property_seo_description_neighborhood": "Uncover Mansfield's charm at Oak Wood Apartments! Enjoy spacious two and three-bedroom homes nestled near local favorites and vibrant attractions.",
  "property_seo_title_contact": "Contact Us | Oak Wood Apartments",
  "property_seo_description_contact": "Find your perfect home at Oak Wood Apartments in Mansfield, OH. With two and three-bedroom options, our leasing team is ready to assist. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Mansfield, OH",
  "property_seo_description_faqs": "Unlock the answers to your questions about Oak Wood Apartments! From flexible rent to amenities galore, our FAQs page has everything you need to know.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mansfield, OH",
  "property_seo_description_reviews": "Join the Oak Wood Apartments community in Mansfield, OH! Read resident reviews and see why our unique amenities and welcoming vibe are the perfect fit for you!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mansfield, OH",
  "property_seo_description_applynow": "Embrace comfort at Oak Wood Apartments in Mansfield, OH. Choose from spacious two & three-bedroom layouts with pet-friendly perks. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Oak Wood Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Oak Wood Apartments in Mansfield, OH! Log in to manage your rent, maintenance requests, and community updates—all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Oak Wood Apartments",
  "property_seo_description_referafriend": "Refer a friend to Oak Wood Apartments in Mansfield, OH! Great friends make great neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Oak Wood Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Oak Wood Apartments in Mansfield, OH. Schedule your tour today and step into your new home surrounded by nature and comfort!",
  "property_seo_title_privacy": "Privacy Policy | Oak Wood Apartments",
  "property_seo_description_privacy": "Your privacy matters at Oak Wood Apartments in Mansfield, OH. Learn how we protect your information and ensure a secure living experience. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Oak Wood Apartments",
  "property_seo_description_accessibility": "Discover seamless living at Oak Wood Apartments in Mansfield, OH—where digital inclusion and accessibility foster a welcoming community for all!",
  "property_seo_title_sitemap": "Sitemap | Oak Wood Apartments",
  "property_seo_description_sitemap": "Navigate your way to your new home at Oak Wood Apartments in Mansfield, OH. Check out our sitemap to find the perfect fit for your lifestyle!",
  "property_seo_title_thankyou": "Thank You | Oak Wood Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Oak Wood Apartments in Mansfield, OH, is excited to connect with you. Expect a prompt response from our dedicated team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Mansfield, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790113565456",
  "amenities": [
    {
      "id": "ec_18960659d7c406d70e16bbb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000286",
      "title": "Convenient Location",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9aaf16f5b3cce58a4f25c85c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000488",
      "title": "On-Site Management Team",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68e16b04a7bde616881d5897",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000617",
      "title": "Professional Management",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_656661f7ca1fbcc33081c177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000619",
      "title": "Ideal Location",
      "amount": "0.0000",
      "description": "Nearby Shopping and Entertainment",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7cd63b9dace0c845c349be7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000701",
      "title": "24 Hour Emergency Maintenance",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7113715cd566881e14615742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000702",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Flexible Rent Payments",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ceb3e9929a9d5436d01a9ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000716",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Dog Park",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a327efcd9465186740c2f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000717",
      "title": "Laundry Facility",
      "amount": "0.0000",
      "description": "Laundry Facility",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_772e05fd8ea212800d592310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000721",
      "title": "Controlled Access",
      "amount": "0.0000",
      "description": "Controlled Access",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c167dd276115e9af0e55e44c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000727",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09ce2fc35ef756293ece161d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000736",
      "title": "Online Payments",
      "amount": "0.0000",
      "description": "Online Payments",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1b3702fcd7c0b31d1efed28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000663",
      "title": "Patio / Balcony",
      "amount": "0.0000",
      "description": "Balcony / Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d0ed30b486a7a244a6539ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000683",
      "title": "Kitchen Disposal",
      "amount": "0.0000",
      "description": "Garbage disposal",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f1ae324fc5cbba5477731ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000684",
      "title": "Walk-in Closets",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74736caddb83b38c6634c765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000692",
      "title": "High Speed Internet",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1b625aeb0de72e1219db46f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000693",
      "title": "Central Heat & Air",
      "amount": "0.0000",
      "description": "Central Heat & Air",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4e60c24bba4bf955e6ce23b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "P000000696",
      "title": "Oven",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_deaec51c2fde36712141e8e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "S100000159",
      "title": "Refrigerator",
      "amount": "15.0000",
      "description": "Side-by-side refrigerator with no ice dispenser",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72c62d83eb519244907689b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "realpage",
      "external_id": "S100000264",
      "title": "Dishwasher",
      "amount": "0.0000",
      "description": "Dishwasher",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_13385846-3ead-4a7f-8924-499a8c053d72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-61cd-72bf-a48e-b907150f5711.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and doorway to hallway at Oak Wood Apartments.",
        "public_id": "019d63b9-61cd-72bf-a48e-b907150f5711",
        "storage_key": "property/6767906449167361/019d63b9-61cd-72bf-a48e-b907150f5711.webp",
        "width": 1250,
        "height": 833
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet with sliding doors and a neutral carpet. An open doorway reveals a hallway with additional features.",
      "link": "",
      "alt_text": "Bedroom with closet and doorway to hallway at Oak Wood Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16fc4fb4-b69d-4062-bcc5-5b6a0cbc08b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4b5e-7704-8b34-2436258c4ad4.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass door and vertical blinds at Oak Wood Apartments.",
        "public_id": "019d63b9-4b5e-7704-8b34-2436258c4ad4",
        "storage_key": "property/6767906449167361/019d63b9-4b5e-7704-8b34-2436258c4ad4.webp",
        "width": 1250,
        "height": 833
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a sliding glass door with vertical blinds, offering ample natural light and access to the outdoors. Neutral carpet and walls create a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Living room with sliding glass door and vertical blinds at Oak Wood Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4a9c525-420e-46dd-808b-4dc465d49635",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4bbb-74d7-994a-0b68415c9416.webp",
      "image_media": {
        "alt_text": "Oak Wood Apartments monument sign with a brick building in the background at Oak Wood Apartments.",
        "public_id": "019d63b9-4bbb-74d7-994a-0b68415c9416",
        "storage_key": "property/6767906449167361/019d63b9-4bbb-74d7-994a-0b68415c9416.webp",
        "width": 1000,
        "height": 696
      },
      "title": "Community",
      "description": "Welcome to Oak Wood Apartments, featuring a prominent monument sign and beautifully maintained grounds.",
      "link": "",
      "alt_text": "Oak Wood Apartments monument sign with a brick building in the background at Oak Wood Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39b614d4-afa6-43fd-85b8-2e21f1b9aba9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4b60-77bf-80ff-83ec565986e5.webp",
      "image_media": {
        "alt_text": "White kitchen with stove, refrigerator, sink, and cabinets at Oak Wood Apartments.",
        "public_id": "019d63b9-4b60-77bf-80ff-83ec565986e5",
        "storage_key": "property/6767906449167361/019d63b9-4b60-77bf-80ff-83ec565986e5.webp",
        "width": 864,
        "height": 1152
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white appliances, ample cabinet space, and a bright, airy atmosphere.",
      "link": "",
      "alt_text": "White kitchen with stove, refrigerator, sink, and cabinets at Oak Wood Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a8db4753-36c3-4bde-8c00-608524056846",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Der Dutchman",
      "poi_type": "Restaurants",
      "poi_address": "720 State Rte 97 W, Bellville, OH 44813, USA",
      "poi_short_description": "Down-home American joint offering hot & cold buffets of traditional comfort fare, plus a salad bar.",
      "poi_long_description": "Diners like this restaurant's delicious, homemade Amish-style comfort food, especially the fried chicken, roast beef, and mashed potatoes, with many highlighting the fresh and well-stocked buffet. They also mention the reasonable prices and the clean, welcoming atmosphere, including spotless restrooms. Guests consistently praise the staff for being friendly, attentive, and providing excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-6d0f-777b-8d00-752f59ec62a0.webp",
      "poi_featured_image_media": {
        "alt_text": "Der Dutchman building exterior with lights and a dinosaur statue in the foreground.",
        "public_id": "019dbbbc-6d0f-777b-8d00-752f59ec62a0",
        "storage_key": "property/6767906449167361/019dbbbc-6d0f-777b-8d00-752f59ec62a0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://dhgroup.com/restaurants/der-dutchman-bellville-oh",
      "poi_directions_map_url": "https://maps.google.com/?cid=7377982968939228733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "der-dutchman",
      "poi_latitude": "40.6448858",
      "poi_longitude": "-82.5427782",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-886-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019dbbbc-c0b0-76de-b9ae-e6a2201305ff",
        "storage_key": "property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0tY_7bAOYgRPS6BhmvcY2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_edbbebf1-d371-4bca-98fd-14a3396857ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Buckeye Express Diner",
      "poi_type": "Restaurants",
      "poi_address": "810 OH-97, Bellville, OH 44813, USA",
      "poi_short_description": "Ohio-themed eatery in a vintage rail car offering American comfort food & an outdoor play area.",
      "poi_long_description": "People say this diner serves delicious burgers, fresh-cut fries, and onion rings. They highlight the unique train car dining experience, the generous portions, and the fun, casual atmosphere. They also like the friendly and accommodating staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-5f58-76af-ad4b-1ecb8844448e.webp",
      "poi_featured_image_media": {
        "alt_text": "Dining area with tables and chairs, decorated with framed photos and sports memorabilia.",
        "public_id": "019dbbbc-5f58-76af-ad4b-1ecb8844448e",
        "storage_key": "property/6767906449167361/019dbbbc-5f58-76af-ad4b-1ecb8844448e.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://buckeyeexpressdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17127291094169714730&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buckeye-express-diner",
      "poi_latitude": "40.6470692",
      "poi_longitude": "-82.5410436",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-886-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019dbbbc-c0b0-76de-b9ae-e6a2201305ff",
        "storage_key": "property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJedf-vJnGOYgRKoCygIFcsO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_5bb66c2f-22a8-4c5c-abae-287c85eb6c5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "100 Stander Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Diners praise the restaurant's delicious pancakes, meatloaf, and chicken fried steak, describing the food as hearty and fresh. The friendly staff and pleasant, old-timey atmosphere are also frequently highlighted.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-673c-772e-acda-76f18d272449.webp",
      "poi_featured_image_media": {
        "alt_text": "Cracker Barrel Old Country Store exterior with rocking chairs and blooming crepe myrtle trees.",
        "public_id": "019d63b7-673c-772e-acda-76f18d272449",
        "storage_key": "property/6767906449167361/019d63b7-673c-772e-acda-76f18d272449.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/oh/mansfield/224/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=15956311967044293385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "40.6930612",
      "poi_longitude": "-82.5105669",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-774-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019dbbbc-c0b0-76de-b9ae-e6a2201305ff",
        "storage_key": "property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc3SnVbbBOYgRCVP9oDE1cN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d400b0ac-f133-4cdc-bfb2-a778edda201a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "2470 Possum Run Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Customers consistently praise this restaurant for its well-seasoned food offered in generous portions, alongside a fast and convenient online ordering system. Reviewers also frequently mention the friendly and efficient staff, noting that the store is typically clean and well-stocked.\n\nSome reviews mention the food can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-614f-740f-94fb-19464a326859.webp",
      "poi_featured_image_media": {
        "alt_text": "Chipotle restaurant exterior with logo and dining area visible through windows.",
        "public_id": "019d63b7-614f-740f-94fb-19464a326859",
        "storage_key": "property/6767906449167361/019d63b7-614f-740f-94fb-19464a326859.webp",
        "width": 1908,
        "height": 2140
      },
      "poi_business_url": "https://locations.chipotle.com/oh/mansfield/2470-possum-run-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2207",
      "poi_directions_map_url": "https://maps.google.com/?cid=4271350046611632069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "40.6914204",
      "poi_longitude": "-82.51252740000001",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-775-0072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019dbbbc-c0b0-76de-b9ae-e6a2201305ff",
        "storage_key": "property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1yJwubHBOYgRxW-inzziRjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f947cd40-de3b-4dd3-b736-958b39d1a08c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "145 Stander Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Diners say this restaurant offers delicious food, including great steaks and appetizers like spinach and artichoke dip, with meals often served hot and fast. They also highlight the exceptional service, frequently praising staff member Lori for being friendly, attentive, and personable.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-5e25-7090-8ae3-6a68dd9076b2.webp",
      "poi_featured_image_media": {
        "alt_text": "Applebee's Neighborhood Grill & Bar exterior with signage.",
        "public_id": "019dbbbc-5e25-7090-8ae3-6a68dd9076b2",
        "storage_key": "property/6767906449167361/019dbbbc-5e25-7090-8ae3-6a68dd9076b2.webp",
        "width": 2048,
        "height": 1070
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/oh/mansfield/145-stander-avenue-75045?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=75045&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2067651813592036429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "40.6942227",
      "poi_longitude": "-82.5088936",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-756-9303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019dbbbc-c0b0-76de-b9ae-e6a2201305ff",
        "storage_key": "property/6767906449167361/019dbbbc-c0b0-76de-b9ae-e6a2201305ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZUQ-67fBOYgRTXRYnF7GsRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d2c7f454-b141-49df-a9a1-0e9f9dd968b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "1500 Lexington Ave, Mansfield, OH 44907, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store is large, clean, and well-stocked with a great variety of products, including gluten-free options. They also highlight the friendly staff and convenient shopping experience.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b6-8d31-71ab-a263-0ea7627d3527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d63b6-8d31-71ab-a263-0ea7627d3527",
        "storage_key": "property/6767906449167361/019d63b6-8d31-71ab-a263-0ea7627d3527.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/mansfield/lexington-avenue/016/00836?cid=loc_01600836_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1679559421267566714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "40.7187371",
      "poi_longitude": "-82.54933559999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-756-6049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbbbc-c0ae-7668-986f-fadd6787ffe5",
        "storage_key": "property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3WN4hqfqOYgRemDQG2X-Thc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6cbfd703-c567-4b0e-806e-f4f116992bde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 August Dr, Mansfield, OH 44906, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Customers consistently praise this home improvement store for its great selection and inventory of items suitable for various projects, alongside well-organized and clean stores. Reviewers also frequently highlight the knowledgeable staff who provide excellent service.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b6-8d30-753e-bd39-9328b851bf84.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior with an American flag waving.",
        "public_id": "019d63b6-8d30-753e-bd39-9328b851bf84",
        "storage_key": "property/6767906449167361/019d63b6-8d30-753e-bd39-9328b851bf84.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Ontario/OH/Mansfield/44906/3846?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6517060223596331756&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "40.7639433",
      "poi_longitude": "-82.5868965",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 419-529-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0ae-7668-986f-fe5a1efbab46.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dbbbc-c0ae-7668-986f-fe5a1efbab46",
        "storage_key": "property/6767906449167361/019dbbbc-c0ae-7668-986f-fe5a1efbab46.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBU6zdOGUOYgR7IJJl74_cVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_30dad7c8-64dd-4a58-a01a-f152da3b8710",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1240 Park Ave W, Mansfield, OH 44906, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Customers consistently praise this grocery store for its good selection of products and fresh produce, offered at fair prices. The friendly staff is also frequently highlighted as a positive aspect of the shopping experience.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b6-8d31-71ab-a263-0ea7627d3527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d63b6-8d31-71ab-a263-0ea7627d3527",
        "storage_key": "property/6767906449167361/019d63b6-8d31-71ab-a263-0ea7627d3527.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/mansfield/park-avenue/016/00518?cid=loc_01600518_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4765160084081377956&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "40.7608966",
      "poi_longitude": "-82.56093349999999",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-528-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbbbc-c0ae-7668-986f-fadd6787ffe5",
        "storage_key": "property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8LVYdXqOYgRpIKKfdk_IUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a4cf0867-a819-4350-bd2f-a44aba84ba72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Apple Hill Orchards",
      "poi_type": "Shopping & Retail",
      "poi_address": "1175 Lexington Ontario Rd, Lexington, OH 44904, USA",
      "poi_short_description": "Apple- and pumpkin-picking farm offering cider and homemade goods.",
      "poi_long_description": "People say this orchard offers delicious apple donuts, fresh apples, and a variety of baked goods like blueberry scones and cinnamon rolls. They also highlight the friendly and helpful staff, as well as the fun, family-friendly atmosphere with animals and a play area. Visitors mention the convenient drive-thru and the amazing apple cider.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-5fc4-766c-938d-bc1091b78fa2.webp",
      "poi_featured_image_media": {
        "alt_text": "Apple Hill signage with a red apple logo and two towers in the background.",
        "public_id": "019dbbbc-5fc4-766c-938d-bc1091b78fa2",
        "storage_key": "property/6767906449167361/019dbbbc-5fc4-766c-938d-bc1091b78fa2.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://applehillorchards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17815271952677246171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "apple-hill-orchards",
      "poi_latitude": "40.7267403",
      "poi_longitude": "-82.61636419999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-884-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbbbc-c0ae-7668-986f-fadd6787ffe5",
        "storage_key": "property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQsmN4-VOYgR25ROnHOPPPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b0743c4b-6731-44c1-9d90-e084c5b74f00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Stoodt's Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "184 Main St, Bellville, OH 44813, USA",
      "poi_short_description": "Small-town grocery store featuring organic products and prepared foods, plus homemade donuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-6028-76d5-a30d-c2b4628e39a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbbc-6028-76d5-a30d-c2b4628e39a3",
        "storage_key": "property/6767906449167361/019dbbbc-6028-76d5-a30d-c2b4628e39a3.webp",
        "width": 1280,
        "height": 1065
      },
      "poi_business_url": "http://www.stoodtsfreshmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058882637716001119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stoodts-fresh-market",
      "poi_latitude": "40.61861690000001",
      "poi_longitude": "-82.512081",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-719-8059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbbbc-c0ae-7668-986f-fadd6787ffe5",
        "storage_key": "property/6767906449167361/019dbbbc-c0ae-7668-986f-fadd6787ffe5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYkyaNzGOYgRXxHMoSoLeZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_22da0474-a6c9-4915-b3a2-e908fa9f4352",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Ashland College of Nursing",
      "poi_type": "Education",
      "poi_address": "1020 S Trimble Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-cd2d-72aa-a34d-222cf096fef3.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with columns and flags",
        "public_id": "019d63b7-cd2d-72aa-a34d-222cf096fef3",
        "storage_key": "property/6767906449167361/019d63b7-cd2d-72aa-a34d-222cf096fef3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.ashland.edu/conhs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3214710252956215430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ashland-college-of-nursing",
      "poi_latitude": "40.7375495",
      "poi_longitude": "-82.5528246",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0ad-762e-a087-68271ba3648e.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbbbc-c0ad-762e-a087-68271ba3648e",
        "storage_key": "property/6767906449167361/019dbbbc-c0ad-762e-a087-68271ba3648e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_VqJe7DqOYgRhuhCW_HxnCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6f0d36f8-a50e-4979-a17d-3f5e18136daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Lexington High School Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Lexington, OH 44904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-8141-75b8-8bb5-27e53147e2f8.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a school campus including a football field with track and tennis courts.",
        "public_id": "019dbbbc-8141-75b8-8bb5-27e53147e2f8",
        "storage_key": "property/6767906449167361/019dbbbc-8141-75b8-8bb5-27e53147e2f8.webp",
        "width": 3072,
        "height": 1726
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=2215",
      "poi_directions_map_url": "https://maps.google.com/?cid=3333872382189245715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lexington-high-school-football-stadium",
      "poi_latitude": "40.672186",
      "poi_longitude": "-82.5888031",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0fa-71fe-a4cc-c1a5aefed86f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graphic icon of two abstract figures sitting at a table",
        "public_id": "019dbbbc-c0fa-71fe-a4cc-c1a5aefed86f",
        "storage_key": "property/6767906449167361/019dbbbc-c0fa-71fe-a4cc-c1a5aefed86f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRT9-Jey_OYgRExXgmkRLRC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_17ebd3b6-2955-4682-9c31-b5ac97f8ed46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Mansfield 1812 Blockhouse",
      "poi_type": "Entertainment",
      "poi_address": "100 Brinkerhoff Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-3e95-72a9-beb0-e5fc9bc9180a.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic log cabin with a stone chimney and a covered porch.",
        "public_id": "019d63b7-3e95-72a9-beb0-e5fc9bc9180a",
        "storage_key": "property/6767906449167361/019d63b7-3e95-72a9-beb0-e5fc9bc9180a.webp",
        "width": 1536,
        "height": 2048
      },
      "poi_business_url": "https://reach-site.webflow.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1117984919052475948&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mansfield-1812-blockhouse",
      "poi_latitude": "40.7565103",
      "poi_longitude": "-82.5430884",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c10f-7129-831a-4204a7da4882.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside",
        "public_id": "019dbbbc-c10f-7129-831a-4204a7da4882",
        "storage_key": "property/6767906449167361/019dbbbc-c10f-7129-831a-4204a7da4882.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zygBvfrOYgRLN5dTFzhgw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0bbb5584-dfeb-45bf-bacf-41e287a83717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Raemelton Farm",
      "poi_type": "Entertainment",
      "poi_address": "Mansfield, OH 44906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-48bb-7013-b319-a95de33b2465.webp",
      "poi_featured_image_media": {
        "alt_text": "Girl in a purple jacket and helmet smiling next to a horse in an indoor arena.",
        "public_id": "019d63b7-48bb-7013-b319-a95de33b2465",
        "storage_key": "property/6767906449167361/019d63b7-48bb-7013-b319-a95de33b2465.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9885165908287116932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raemelton-farm",
      "poi_latitude": "40.7430503",
      "poi_longitude": "-82.5472901",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40aFNnXrOYgRhFZBDQUqL4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_275e1248-85d9-4cbd-9504-7a05cc3cf005",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "The Bellville-Jefferson Township Historical Society Museum",
      "poi_type": "Entertainment",
      "poi_address": "167 Main St, Bellville, OH 44813, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-83ac-758a-82ff-c70577f97f02.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with white shutters and an American flag on a flagpole. Signage indicates a historical society museum.",
        "public_id": "019dbbbc-83ac-758a-82ff-c70577f97f02",
        "storage_key": "property/6767906449167361/019dbbbc-83ac-758a-82ff-c70577f97f02.webp",
        "width": 3072,
        "height": 2307
      },
      "poi_business_url": "http://bellvilleohiohisto.wix.com/homepage",
      "poi_directions_map_url": "https://maps.google.com/?cid=9164201249808095090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-bellville-jefferson-township-historical-society-museum",
      "poi_latitude": "40.6190127",
      "poi_longitude": "-82.5111082",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-545-0975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c10f-7129-831a-4204a7da4882.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside",
        "public_id": "019dbbbc-c10f-7129-831a-4204a7da4882",
        "storage_key": "property/6767906449167361/019dbbbc-c10f-7129-831a-4204a7da4882.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4x2EdzGOYgRcpcAkXvILX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7b0ce722-5da7-4cc8-bed1-ad6c8413b933",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Phillips Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "371 Cline Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-5053-77cc-b903-3c2eb63a7ca5.webp",
      "poi_featured_image_media": {
        "alt_text": "Phillips Animal Hospital building exterior with monument sign.",
        "public_id": "019d63b8-5053-77cc-b903-3c2eb63a7ca5",
        "storage_key": "property/6767906449167361/019d63b8-5053-77cc-b903-3c2eb63a7ca5.webp",
        "width": 1835,
        "height": 971
      },
      "poi_business_url": "https://phillipsvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9169289949580284949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phillips-animal-hospital",
      "poi_latitude": "40.7469107",
      "poi_longitude": "-82.5302069",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-526-4212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X_2IVnqOYgRFdRKz6DcP38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_cd7102d2-600e-4749-8ed0-17be82e55c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Appleseed Valley Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2690 Lexington Ave, Mansfield, OH 44904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-bc36-76ad-9e76-8988c41810ad.webp",
      "poi_featured_image_media": {
        "alt_text": "German Shepherd at vet clinic, being held by a leash.",
        "public_id": "019d63b8-bc36-76ad-9e76-8988c41810ad",
        "storage_key": "property/6767906449167361/019d63b8-bc36-76ad-9e76-8988c41810ad.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://appleseedvalleyvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8620096328050888089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "appleseed-valley-veterinary-hospital",
      "poi_latitude": "40.6850805",
      "poi_longitude": "-82.5669193",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 419-884-1074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXrIu4a_OYgRmU0fa_C7oHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7b65133a-b9f0-4506-a7f6-6837e4a8dc9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "1452 Lexington Ave, Mansfield, OH 44907, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-a42f-719f-80f0-83125672310f.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app displayed on two iPhones.",
        "public_id": "019d63b7-a42f-719f-80f0-83125672310f",
        "storage_key": "property/6767906449167361/019d63b7-a42f-719f-80f0-83125672310f.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/oh/mansfield/1452-lexington-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb-post",
      "poi_directions_map_url": "https://maps.google.com/?cid=4482493939019937313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "40.7198066",
      "poi_longitude": "-82.54857580000001",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-756-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb23MzqDqOYgRIfYf_3wENT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_ad5ab53e-c999-4b62-9df9-3867ed8f9dbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Heart of Ohio Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "5780 OH-13, Bellville, OH 44813, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b7-bd78-7678-a9dd-742ffc231e99.webp",
      "poi_featured_image_media": {
        "alt_text": "Children practicing gymnastics in a large gym with blue mats.",
        "public_id": "019d63b7-bd78-7678-a9dd-742ffc231e99",
        "storage_key": "property/6767906449167361/019d63b7-bd78-7678-a9dd-742ffc231e99.webp",
        "width": 480,
        "height": 600
      },
      "poi_business_url": "http://www.heartofohioathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15226544721773116328&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heart-of-ohio-athletics",
      "poi_latitude": "40.601249",
      "poi_longitude": "-82.51571469999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 419-564-1641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRw9WApLHOYgRqLviMcCNT9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6b8c4a5f-f923-462b-850d-0d62b155e132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Akers Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "885 S Main St, Mansfield, OH 44907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-8e88-71db-b083-b2db7dc254fc.webp",
      "poi_featured_image_media": {
        "alt_text": "Two dogs playing on a carpeted floor in an apartment living room.",
        "public_id": "019dbbbc-8e88-71db-b083-b2db7dc254fc",
        "storage_key": "property/6767906449167361/019dbbbc-8e88-71db-b083-b2db7dc254fc.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.facebook.com/AkersVeterinary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16820464559684434544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "akers-veterinary-hospital",
      "poi_latitude": "40.7349346",
      "poi_longitude": "-82.5129438",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-756-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1IBSmfqOYgRcLoJ_WVLbuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d9106605-170c-4a3a-b5df-b642eada4df4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Lilac Hill Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1300 Middle Bellville Rd, Mansfield, OH 44904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-cbe9-74c8-b5f6-787068806222.webp",
      "poi_featured_image_media": {
        "alt_text": "A Basset Hound wearing a medical cone.",
        "public_id": "019d63b8-cbe9-74c8-b5f6-787068806222",
        "storage_key": "property/6767906449167361/019d63b8-cbe9-74c8-b5f6-787068806222.webp",
        "width": 2313,
        "height": 3072
      },
      "poi_business_url": "http://www.lilachillvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4612315784620343900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lilac-hill-veterinary-hospital",
      "poi_latitude": "40.7237898",
      "poi_longitude": "-82.5398184",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-756-2227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9u5sJjqOYgRXAI53sQ8AkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_42e20a5f-e91d-4871-9741-b8874072d413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Buckeye Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "1339 Park Ave W, Mansfield, OH 44906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-49ba-752c-84ff-3505ecdb3bf5.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of hands with abstract pink, purple, and black nail art.",
        "public_id": "019d63b8-49ba-752c-84ff-3505ecdb3bf5",
        "storage_key": "property/6767906449167361/019d63b8-49ba-752c-84ff-3505ecdb3bf5.webp",
        "width": 1200,
        "height": 1600
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13635470400402216329&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buckeye-nails",
      "poi_latitude": "40.7590242",
      "poi_longitude": "-82.56410489999999",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-522-1448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UEigSqVOYgRidVT2RXsOr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_58a8b7ff-e28a-48c8-a7e5-f431b5e2f819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Clearfork Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "177 Hines Ave, Bellville, OH 44813, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-4128-740d-8ab4-bfc0f372e70b.webp",
      "poi_featured_image_media": {
        "alt_text": "A dark brown dog wearing an orange vest and collar sits patiently, panting with its tongue out.",
        "public_id": "019d63b8-4128-740d-8ab4-bfc0f372e70b",
        "storage_key": "property/6767906449167361/019d63b8-4128-740d-8ab4-bfc0f372e70b.webp",
        "width": 2992,
        "height": 2992
      },
      "poi_business_url": "http://www.appleseedvalleyvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7501943926172400344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clearfork-veterinary-hospital",
      "poi_latitude": "40.6206802",
      "poi_longitude": "-82.5044443",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-886-4733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOd-nZ8TGOYgR2Lpn_EBCHGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e4a5299b-d1db-4730-b2b2-32817eb9cc57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Fat Joes",
      "poi_type": "Health and Wellness",
      "poi_address": "569 S Main St, Mansfield, OH 44907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-b520-769b-968f-a7a7a6dda107.webp",
      "poi_featured_image_media": {
        "alt_text": "Waiting area inside a barber shop with chairs and TVs.",
        "public_id": "019d63b8-b520-769b-968f-a7a7a6dda107",
        "storage_key": "property/6767906449167361/019d63b8-b520-769b-968f-a7a7a6dda107.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10335022806532228009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fat-joes",
      "poi_latitude": "40.742862",
      "poi_longitude": "-82.51572139999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 567-303-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVXxEFbqOYgRqQPqOHxgbY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_b13e1b1d-c1e6-4c48-bffa-208b3ab7c80b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "OhioHealth Mansfield Hospital and Emergency Department",
      "poi_type": "Health and Wellness",
      "poi_address": "335 Glessner Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-7ece-7634-b76c-17cc2239cf44.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a modern brick building with an American flag flying.",
        "public_id": "019d63b8-7ece-7634-b76c-17cc2239cf44",
        "storage_key": "property/6767906449167361/019d63b8-7ece-7634-b76c-17cc2239cf44.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.ohiohealth.com/locations/hospitals/mansfield-hospital/?utm_source=yext&utm_medium=listings&utm_campaign=websiteclicksfacility",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107658932139026326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohiohealth-mansfield-hospital-and-emergency-department",
      "poi_latitude": "40.752648",
      "poi_longitude": "-82.5295987",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-526-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c101-76ea-90d1-939f04a27fd4.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019dbbbc-c101-76ea-90d1-939f04a27fd4",
        "storage_key": "property/6767906449167361/019dbbbc-c101-76ea-90d1-939f04a27fd4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyx2imPzqOYgRlmdvHu4xXw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fd5eab1b-8d2c-465d-9d23-6b8bb066b0d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Third Street Family Health Services",
      "poi_type": "Health and Wellness",
      "poi_address": "600 W 3rd St, Mansfield, OH 44903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-9994-72c9-a409-a8c1bc12beef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbbc-9994-72c9-a409-a8c1bc12beef",
        "storage_key": "property/6767906449167361/019dbbbc-9994-72c9-a409-a8c1bc12beef.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thirdstreetfamily.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843632129112347202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "third-street-family-health-services",
      "poi_latitude": "40.7606841",
      "poi_longitude": "-82.5373412",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-522-6191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c101-76ea-90d1-939f04a27fd4.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019dbbbc-c101-76ea-90d1-939f04a27fd4",
        "storage_key": "property/6767906449167361/019dbbbc-c101-76ea-90d1-939f04a27fd4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjRSUqR_rOYgRQhKh71qcdic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_c634661b-d619-43ce-99ae-97a585882d61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Deer Ridge Golf Club & Black Dog Tavern",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Comfort Plaza Dr, Bellville, OH 44813, USA",
      "poi_short_description": "Casual golf course featuring a challenging layout, a bar and an eatery known for burgers.",
      "poi_long_description": "People say this golf course offers a challenging layout with hills, valleys, and beautiful views, and the restaurant serves delicious food with a wide variety of options. They also highlight the reasonable prices for both the course and the food, as well as the friendly and accommodating staff. Visitors appreciate the great atmosphere, including outdoor seating with scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-7c1a-736f-b09c-4ae7b32f5b6e.webp",
      "poi_featured_image_media": {
        "alt_text": "Log cabin style building with a large wooden deck and green roof, surrounded by trees and a golf course.",
        "public_id": "019d63b8-7c1a-736f-b09c-4ae7b32f5b6e",
        "storage_key": "property/6767906449167361/019d63b8-7c1a-736f-b09c-4ae7b32f5b6e.webp",
        "width": 1188,
        "height": 666
      },
      "poi_business_url": "http://www.deerridgegc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6556736278356442198&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "deer-ridge-golf-club--black-dog-tavern",
      "poi_latitude": "40.6475753",
      "poi_longitude": "-82.53691859999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-886-7090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0f2-719c-8a34-c2e3587d7265.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing a person playing soccer",
        "public_id": "019dbbbc-c0f2-719c-8a34-c2e3587d7265",
        "storage_key": "property/6767906449167361/019dbbbc-c0f2-719c-8a34-c2e3587d7265.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43brjcfAOYgRVjxa9ec0_lo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_b4ab290d-6050-4946-bab9-3f58f6da95c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Kingwood Center Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "50 N Trimble Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "Former estate grounds spanning 47 acres featuring a variety of formal gardens, with tours available.",
      "poi_long_description": "Visitors say this garden and historic home venue features beautifully curated grounds, impressive greenhouses, and a fascinating mansion with well-maintained rooms. They also highlight the friendly and informative staff, who provide excellent guidance and stories about the estate. Guests mention the cafe offers good food and snacks, and the gift shop has unique selections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-90c9-74f8-8fde-563b63014ae7.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the historic brick apartment building with arched entryway and symmetrical windows.",
        "public_id": "019d63b8-90c9-74f8-8fde-563b63014ae7",
        "storage_key": "property/6767906449167361/019d63b8-90c9-74f8-8fde-563b63014ae7.webp",
        "width": 2119,
        "height": 1192
      },
      "poi_business_url": "http://www.kingwoodcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1898681523339425512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kingwood-center-gardens",
      "poi_latitude": "40.760457",
      "poi_longitude": "-82.5515482",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 419-522-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6VwH07rOYgR6HY-LMl4WRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_2d8bbeff-a352-4af5-8bb3-7e7ae9658418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Ohio Bird Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3774 Orweiler Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "Nature preserve and educational resource for wildlife with a focus on birds and an aviary.",
      "poi_long_description": "People say this nature preserve offers a songbird aviary, hiking trails, and a treehouse. They highlight the peaceful and welcoming atmosphere, and the informative signage. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b8-9dbf-724a-9ac2-e9a51751a387.webp",
      "poi_featured_image_media": {
        "alt_text": "Barn owl perched on a tree branch with a wooden boardwalk and autumn foliage in the background.",
        "public_id": "019d63b8-9dbf-724a-9ac2-e9a51751a387",
        "storage_key": "property/6767906449167361/019d63b8-9dbf-724a-9ac2-e9a51751a387.webp",
        "width": 1920,
        "height": 1280
      },
      "poi_business_url": "http://www.ohiobirdsanctuary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12900250462030331846&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohio-bird-sanctuary",
      "poi_latitude": "40.72822439999999",
      "poi_longitude": "-82.6473736",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-884-4295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c110-7548-b846-843429b62c8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019dbbbc-c110-7548-b846-843429b62c8a",
        "storage_key": "property/6767906449167361/019dbbbc-c110-7548-b846-843429b62c8a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZ3LFwCWOYgRxv_iXnLlBrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_bffbe36b-f532-4b98-9df1-1a0bbde68d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Sterkel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "790 Hollywood Ln, Mansfield, OH 44907, USA",
      "poi_short_description": "City park featuring a playground, baseball fields, and picnic tables, plus a public restroom.",
      "poi_long_description": "People say this park features updated play equipment for all ages, including a fenced toddler playground, outdoor gym equipment, and an electronic soccer wall. Visitors also highlight the clean facilities, ample parking, and peaceful atmosphere.\n\nSome reviews mention the playground equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-0a00-717b-8f98-694b523b03eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with colorful structures, slides, and a train-themed play area.",
        "public_id": "019d63b9-0a00-717b-8f98-694b523b03eb",
        "storage_key": "property/6767906449167361/019d63b9-0a00-717b-8f98-694b523b03eb.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075627809786518065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sterkel-park",
      "poi_latitude": "40.7365726",
      "poi_longitude": "-82.5229737",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-522-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c110-7548-b846-843429b62c8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019dbbbc-c110-7548-b846-843429b62c8a",
        "storage_key": "property/6767906449167361/019dbbbc-c110-7548-b846-843429b62c8a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYaYJvPTqOYgRMVrbSMtl7Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9f632e40-f22c-44df-b46f-a4c074e3f522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Gorman Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2295 Lexington Ave, Mansfield, OH 44906, USA",
      "poi_short_description": "150-acre preserve with a visitor center & trails, plus naturalist-led hikes & night-sky programs.",
      "poi_long_description": "Visitors say this nature center offers well-maintained trails, opportunities to observe diverse plants and animals, and a clean pavilion with picnic tables. They also highlight the peaceful atmosphere, making it a great spot for photography and quiet hikes. Guests mention the welcoming visitor center, which features animals and indoor restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-26cb-75b2-8d77-50c9d018843b.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk over a pond surrounded by greenery.",
        "public_id": "019d63b9-26cb-75b2-8d77-50c9d018843b",
        "storage_key": "property/6767906449167361/019d63b9-26cb-75b2-8d77-50c9d018843b.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.richlandcountyoh.gov/departments/RichlandCountParksDistrict",
      "poi_directions_map_url": "https://maps.google.com/?cid=1290097879386109782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gorman-nature-center",
      "poi_latitude": "40.699768",
      "poi_longitude": "-82.5563221",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-884-3764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c110-7548-b846-843429b62c8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019dbbbc-c110-7548-b846-843429b62c8a",
        "storage_key": "property/6767906449167361/019dbbbc-c110-7548-b846-843429b62c8a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZytWAzAOYgRVjdLoi9Z5xE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b6cd074b-af26-4680-a3d5-9417746b0c31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "EMERSON",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2500 Park Ave W, Ontario, OH 44906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019efaa2-8d4e-77f2-964e-34218e9f8a93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efaa2-8d4e-77f2-964e-34218e9f8a93",
        "storage_key": "property/6767906449167361/019efaa2-8d4e-77f2-964e-34218e9f8a93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.emersonprocess.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10071209289291200655&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emerson",
      "poi_latitude": "40.7604058",
      "poi_longitude": "-82.6044667",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-529-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8egbwCVOYgRj_jQMn0fxIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_42b69d52-c8f5-415d-a8e9-d58ea710affe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Apollo Printing & Graphics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1356 Lexington Ave #2616, Mansfield, OH 44907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-a468-733f-97a2-fce65e5220d8.webp",
      "poi_featured_image_media": {
        "alt_text": "Apollo Printing & Graphics logo and office equipment.",
        "public_id": "019dbbbc-a468-733f-97a2-fce65e5220d8",
        "storage_key": "property/6767906449167361/019dbbbc-a468-733f-97a2-fce65e5220d8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9233199137090099314&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "apollo-printing--graphics",
      "poi_latitude": "40.7220454",
      "poi_longitude": "-82.54336339999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-709-8268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQXCjDKHqOYgRctiyErLpIoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0dd28d03-8558-47ea-a8ab-049ac151fb2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "poi_name": "Mary McLeod-Bethune Intervention and Enrichment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "271 Hedges St, Mansfield, OH 44902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-a8b4-76a8-9b52-e1943a7b86a1.webp",
      "poi_featured_image_media": {
        "alt_text": "Parking lot with buildings and vehicles.",
        "public_id": "019dbbbc-a8b4-76a8-9b52-e1943a7b86a1",
        "storage_key": "property/6767906449167361/019dbbbc-a8b4-76a8-9b52-e1943a7b86a1.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://mbie-ohio.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14468453220786890109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mary-mcleod-bethune-intervention-and-enrichment-center",
      "poi_latitude": "40.7503013",
      "poi_longitude": "-82.50966129999999",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-526-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbbbc-c0bc-76b2-ba63-9e7b96196d69",
        "storage_key": "property/6767906449167361/019dbbbc-c0bc-76b2-ba63-9e7b96196d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ927t2gHrOYgRfeVbEoxFysg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_7f1b093f-ad0c-4f8f-95cd-b0dcc1439a95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_e61a5266-dfc2-49b6-bd52-76f6338ed7dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a5034640-29ae-4a01-986c-17f2169b780a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_d7ab12a9-fecf-4246-8486-279b913feadc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7f78a718-6c80-491e-ba4d-aee454cb3909",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5eec0992-dd23-4601-9a2c-461a62e41141",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "rating": "5.0",
      "name": "Sierra Weese",
      "text": "My apartment was completely remodeled before I moved in - and though it took longer than expected I was updated on every step and even offered an apartment in a different building if the wait was too long. The lease is easy to understand, and Kendall goes over every bit of it with you upon signing. Maintenance audit notices are given over a week in advance, although it would be nice if there was a different delivery system than leaving it on my door (they fall off and get stepped on)\nOverall, I’ve lived in worse places. Out of the rentals I’ve been in, this is top of the list.",
      "date": "2023-12-06",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-8373-7086-860a-92f660f9ec23",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "owa---oakwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361"
    },
    {
      "lead_collector_id": "019e1ddc-83e4-75fe-8057-72e189652de1",
      "lead_source": "FACEBOOK_ADS",
      "name": "owa---oakwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361"
    },
    {
      "lead_collector_id": "019e1ddc-845a-7110-a18e-3839e286871c",
      "lead_source": "LANDING_PAGE",
      "name": "owa---oakwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-mansfield-oh",
      "search_query": "pet friendly apartments Mansfield OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Mansfield, OH",
      "h2_subtitle": "Discover the ideal pet-friendly apartments in Mansfield, OH. Oak Wood Apartments welcomes you and your furry friends to comfortable living.",
      "page_copy": "Oak Wood Apartments in Mansfield, OH, is your go-to place for pet-friendly living. Our community understands the joy pets bring, and we welcome cats and dogs with open arms. Choose from our spacious two- and three-bedroom layouts designed with you and your animal companions in mind. Residents benefit from a range of amenities like controlled access and convenient online payments, ensuring a seamless living experience.\n\nLocated in the Lexington neighborhood of Mansfield, Oak Wood Apartments provides a desirable blend of peaceful residential living with proximity to nearby shopping and recreational areas. Our on-site management team ensures everything runs smoothly, so you can focus more on quality time with your pet. Make Oak Wood Apartments your new pet-friendly home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Mansfield, OH",
      "seo_description": "Find the perfect pet-friendly apartments in Mansfield, OH. Oak Wood Apartments offer spacious living with amenities perfect for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-lexington-oh",
      "search_query": "air conditioned apartments Lexington OH",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Lexington, OH",
      "h2_subtitle": "Experience comfort in air conditioned apartments in Lexington, OH. Oak Wood Apartments offer a cozy retreat from the summer heat.",
      "page_copy": "At Oak Wood Apartments, nestled in the heart of Lexington, OH, comfort is our priority. With the relief of air-conditioned living, you can stay cool during Mansfield's warmer months. Our spacious two- and three-bedroom homes provide the perfect setting with essential features, including a fully equipped kitchen and convenient online payment options.\n\nLiving in Oak Wood Apartments means enjoying controlled access and a dedicated on-site management team ready to assist you. Our community is pet-friendly, adding more warmth to your home climate. Take advantage of being close to local shopping and amenities, making Oak Wood Apartments the ideal air-conditioned retreat in vibrant Lexington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Lexington, OH",
      "seo_description": "Stay cool at Oak Wood Apartments in Lexington, OH. Experience comfortable living with air conditioning and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-with-playground-richland-county",
      "search_query": "apartments with playground in Richland County",
      "category": "Amenity",
      "h1_title": "Apartments with Playground in Richland County",
      "h2_subtitle": "Find great apartments with a playground in Richland County. Enjoy Oak Wood Apartments’ amenities and spacious layouts.",
      "page_copy": "Welcome to Oak Wood Apartments, where families thrive in our community complete with a playground. Located in the heart of Richland County, our apartments offer the perfect setting for families looking for a welcoming environment. Our spacious two- and three-bedroom layouts provide ample room for both relaxation and fun.\n\nResidents benefit from amenities such as a controlled access facility and an attentive on-site management team. With the playground just steps from your front door, your children can enjoy outdoor playtime in a safe setting. Combined with pet-friendly policies and convenient access to local shopping, Oak Wood Apartments in Richland County is an ideal home for families seeking a complete living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Playground in Richland County",
      "seo_description": "Discover Oak Wood Apartments with a playground in Richland County. Enjoy spacious living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "flexible-rent-payment-apartments-44904",
      "search_query": "flexible rent payment apartments 44904",
      "category": "Amenity",
      "h1_title": "Flexible Rent Payment Apartments 44904",
      "h2_subtitle": "Explore flexible rent payment options at Oak Wood Apartments in the 44904 area. Manage your finances with ease in Mansfield's welcoming community.",
      "page_copy": "At Oak Wood Apartments, we understand the importance of financial flexibility, which is why we offer flexible rent payment options perfect for residents in the 44904 area. Located in Mansfield, OH, our community provides a hassle-free living experience, accommodating your financial needs with ease. \n\nChoose from our spacious two- and three-bedroom layouts that come equipped with modern conveniences like online payments and controlled access for added security. Our on-site management team is always here to help, ensuring that your living experience is smooth and stress-free. Enjoy proximity to local shops and amenities while benefiting from the adaptable financial solutions Oak Wood Apartments offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flexible Rent Payment Apartments 44904",
      "seo_description": "Manage your finances easily at Oak Wood Apartments in 44904. Enjoy flexible rent options and a comfortable living in Mansfield, OH.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-near-mansfield",
      "search_query": "dishwasher equipped apartments near Mansfield",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments Near Mansfield",
      "h2_subtitle": "Discover dishwasher-equipped apartments close to Mansfield. Oak Wood Apartments offer modern living with convenient amenities.",
      "page_copy": "At Oak Wood Apartments, just a short drive from Mansfield, enjoy the convenience of dishwasher-equipped living spaces. Our two- and three-bedroom layouts come fitted with modern kitchen amenities, including dishwashers, making daily chores effortless. Experience the ease of maintaining a tidy home as you settle into our welcoming community.\n\nNestled in the vicinity of Mansfield, Oak Wood Apartments offers more than just a home; it's a lifestyle upgrade with controlled access, flexible rent payments, and a dedicated on-site management team. Relish the pet-friendly living and take advantage of nearby shopping and local attractions, all while enjoying the comfort of having a dishwasher in your apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments Near Mansfield",
      "seo_description": "Find the perfect dishwasher-equipped living at Oak Wood Apartments near Mansfield, offering modern layouts and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-mansfield-oh",
      "search_query": "two bedroom apartments mansfield oh",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Mansfield, OH",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Mansfield, OH at Oak Wood Apartments. Enjoy modern amenities and a convenient location.",
      "page_copy": "Looking for two-bedroom apartments in Mansfield, OH? Oak Wood Apartments offers spacious and thoughtfully designed layouts perfect for any lifestyle. Our two-bedroom homes are ideal for those seeking a balance between comfort and convenience, providing ample space for both relaxation and functionality.\n\nLocated in the charming community of Mansfield, Oak Wood Apartments is more than just a place to live; it's a community where you can thrive. Enjoy modern amenities like a dishwasher, controlled access, and an efficient on-site management team committed to enhancing your living experience. Embrace a pet-friendly lifestyle with easy online rent payments, and explore the nearby shops and amenities that make Mansfield a wonderful place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Mansfield, OH",
      "seo_description": "Explore two-bedroom spaces at Oak Wood Apartments in Mansfield, OH. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-lexington-richland-county",
      "search_query": "three bedroom apartments lexington richland county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Lexington, Richland County",
      "h2_subtitle": "Explore three-bedroom apartments in Lexington, Richland County at Oak Wood Apartments. Enjoy ample living space and amenities fit for families.",
      "page_copy": "Discover the perfect three-bedroom apartments in Lexington, nestled within scenic Richland County, at Oak Wood Apartments. Our spacious three-bedroom layouts offer the ideal setting for families or individuals needing extra room to accommodate their lifestyle needs. \n\nLocated near local attractions and shopping, Oak Wood Apartments provides a range of convenient amenities like controlled access for safety, an on-site management team, and online payment options. Embrace a pet-friendly environment while enjoying modern features such as a dishwasher and range in a community built for comfort and convenience. When living at Oak Wood, you're not just renting an apartment; you're creating a home in Lexington, Richland County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Lexington, Richland",
      "seo_description": "Find spacious three-bedroom living at Oak Wood Apartments in Lexington, Richland County, featuring convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-near-lexington-eastern-elementary-mansfield-oh",
      "search_query": "apartments near lexington eastern elementary mansfield oh",
      "category": "School",
      "h1_title": "Apartments Near Lexington Eastern Elementary, Mansfield",
      "h2_subtitle": "Discover conveniently located apartments near Lexington Eastern Elementary in Mansfield, OH. Oak Wood Apartments offer great amenities and comfort.",
      "page_copy": "Looking for apartments near Lexington Eastern Elementary in Mansfield, OH? Oak Wood Apartments presents the perfect community just a short distance away. Our two- and three-bedroom layouts are spacious and designed with families in mind, making transitions seamless for growing households.\n\nSituated in a prime location, Oak Wood Apartments provides easy access to local schools, parks, and shopping, while ensuring a safe and comfortable environment. Enjoy amenities like controlled access, a playground for kids, and pet-friendly policies, all complemented by our attentive on-site management team. Choose Oak Wood Apartments and embrace a convenient lifestyle near all that Lexington has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lexington Eastern Elementary, Mansfield",
      "seo_description": "Explore Oak Wood Apartments, just a short drive from Lexington Eastern Elementary in Mansfield, OH. Enjoy modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-close-to-central-elementary-school-lexington",
      "search_query": "apartments close to central elementary school lexington",
      "category": "School",
      "h1_title": "Apartments Near Central Elementary School, Lexington",
      "h2_subtitle": "Find spacious apartments near Central Elementary School in Lexington. Ideal for families seeking proximity to education and comfort.",
      "page_copy": "Oak Wood Apartments offers the perfect living solution for families seeking apartments close to Central Elementary School in Lexington. With spacious two- and three-bedroom layouts, our community provides the ideal setting for families prioritizing education and convenience.\n\nLocated in the welcoming neighborhood of Lexington, our apartments offer easy access to local schools like Central Elementary, ensuring a stress-free morning routine. Residents will appreciate the abundance of amenities, including playground facilities, pet-friendly living conditions, and a range of modern appliances. With on-site management and secure, controlled access, Oak Wood Apartments truly embodies a community designed for families to flourish.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Central Elementary School, Lexington",
      "seo_description": "Live near Central Elementary School in Lexington at Oak Wood Apartments, offering great amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "rent-near-western-elementary-school-richland-county",
      "search_query": "rent near western elementary school richland county",
      "category": "School",
      "h1_title": "Rent Near Western Elementary School, Richland",
      "h2_subtitle": "Explore rental options near Western Elementary School in Richland County at Oak Wood Apartments. Perfect for families wanting convenience and space.",
      "page_copy": "Searching for apartment rentals near Western Elementary School in Richland County? Look no further than Oak Wood Apartments, where you will find the perfect blend of convenience and comfort. Our spacious two- and three-bedroom units make an ideal home base for families prioritizing school proximity.\n\nSituated in a great area, Oak Wood Apartments ensure an easy commute to Western Elementary School. Our community offers pet-friendly policies, a playground, and modern conveniences like a dishwasher and range. With an on-site management team and secure controlled access, enjoy peace of mind while living in a vibrant environment tailored for families in Richland County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rent Near Western Elementary School, Richland County",
      "seo_description": "Find ideal rentals at Oak Wood Apartments near Western Elementary School in Richland County with convenient amenities and great living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-by-lexington-junior-high-school",
      "search_query": "apartments by lexington junior high school",
      "category": "School",
      "h1_title": "Apartments by Lexington Junior High School",
      "h2_subtitle": "Discover apartments close to Lexington Junior High School. Oak Wood Apartments offer convenience and community for families in Lexington.",
      "page_copy": "If you're seeking apartments by Lexington Junior High School, Oak Wood Apartments is the perfect choice. Located in the heart of Lexington, our community provides comfortable and convenient living arrangements in proximity to Lexington Junior High.\n\nOur spacious two- and three-bedroom apartments are designed with needs in mind, featuring amenities such as controlled access and an on-site management team. Residents will appreciate the pet-friendly atmosphere, playground, and easy access to local schools and shopping. At Oak Wood Apartments, you'll find a community that supports educational priorities and a comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Lexington Junior High School",
      "seo_description": "Live near Lexington Junior High School at Oak Wood Apartments, offering great amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "housing-near-lexington-high-school-mansfield-ohio",
      "search_query": "housing near lexington high school mansfield ohio",
      "category": "School",
      "h1_title": "Housing Near Lexington High School, Mansfield",
      "h2_subtitle": "Explore comfortable housing options near Lexington High School in Mansfield, Ohio. Oak Wood Apartments provides ideal proximity and community perks.",
      "page_copy": "When searching for housing near Lexington High School in Mansfield, Ohio you will find Oak Wood Apartments an excellent choice. Our community offers spacious two- and three-bedroom apartments, ensuring plenty of room to thrive in a comfortable setting.\n\nSituated conveniently close to Lexington High School, Oak Wood Apartments provides residents with easy access to educational facilities along with a wealth of on-site amenities. Enjoy the benefits of pet-friendly living, a playground for children, controlled access, and a dedicated on-site management team. With flexible payment options and nearby shopping, it’s a community designed for prioritizing quality education and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Lexington High School, Mansfield",
      "seo_description": "Find housing at Oak Wood Apartments near Lexington High School, Mansfield, OH. Convenient proximity and top amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-near-ohio-state-university-mansfield",
      "search_query": "apartments near ohio state university mansfield",
      "category": "School",
      "h1_title": "Apartments Near Ohio State University, Mansfield",
      "h2_subtitle": "Oak Wood Apartments offers ideal living spaces near Ohio State University in Mansfield, providing comfort and convenience for students and faculty alike.",
      "page_copy": "Are you looking for apartments near Ohio State University, Mansfield? Oak Wood Apartments is perfectly situated to meet the needs of students and faculty seeking convenient and comfortable living. With spacious two- and three-bedroom floor plans, our community provides ample space just a short commute from the university.\n\nEnjoy the peaceful surroundings of Mansfield while benefiting from the modern amenities available at Oak Wood Apartments. Our community features controlled access, a dedicated on-site management team, and pet-friendly accommodations. With easy online payment options and nearby shopping centers, everything you need is at your fingertips. Experience stress-free living while pursuing academic goals at Ohio State University, Mansfield.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ohio State University, Mansfield",
      "seo_description": "Discover Oak Wood Apartments near Ohio State University in Mansfield. Perfect for students and faculty, offering comfort and proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "north-central-state-college-nearby-apartments",
      "search_query": "north central state college nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to North Central State College",
      "h2_subtitle": "Find your perfect home just minutes from North Central State College. Oak Wood Apartments offers comfort and convenience for students and staff.",
      "page_copy": "For those attending or working at North Central State College, nearby apartments like Oak Wood Apartments provide an ideal living solution. Nestled in Mansfield, Oak Wood Apartments offers spacious two- and three-bedroom layouts perfect for students or college staff seeking convenient access to campus.\n\nOur community is designed with your needs in mind, featuring essential amenities like controlled access and the convenience of online payments. Enjoy pet-friendly living and the peace of mind provided by an on-site management team. With proximity to North Central State College and nearby shopping options, Oak Wood Apartments is the perfect blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to North Central State College",
      "seo_description": "Live close to North Central State College at Oak Wood Apartments. Enjoy proximity and amenities perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-close-to-mansfield-christian-school",
      "search_query": "apartments close to mansfield christian school",
      "category": "School",
      "h1_title": "Apartments Close to Mansfield Christian School",
      "h2_subtitle": "Discover the convenience of living near Mansfield Christian School. Oak Wood Apartments offers spacious homes perfect for great living.",
      "page_copy": "For families and individuals seeking apartments close to Mansfield Christian School, Oak Wood Apartments is an outstanding choice. Situated in a prime location in Mansfield, our community provides easy access to the school alongside a comfortable and welcoming living environment.\n\nOak Wood Apartments offers two- and three-bedroom units equipped with modern amenities that include controlled access, a playground for children, and pet-friendly policies. Our on-site management team ensures a well-maintained community, ideal for those prioritizing education and convenience. With nearby shopping and flexible rent payments, Oak Wood Apartments delivers the perfect setting for a harmonious lifestyle near Mansfield Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mansfield Christian School",
      "seo_description": "Live near Mansfield Christian School at Oak Wood Apartments. Ideal location with great amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-near-ohiohealth-mansfield-hospital",
      "search_query": "apartments near OhioHealth Mansfield Hospital",
      "category": "Hospital",
      "h1_title": "Apartments Near OhioHealth Mansfield Hospital",
      "h2_subtitle": "Enjoy the convenience of living near OhioHealth Mansfield Hospital. Oak Wood Apartments offers ample space and modern amenities just minutes away.",
      "page_copy": "If you're searching for apartments near OhioHealth Mansfield Hospital, Oak Wood Apartments provides an ideal living solution. Located conveniently in Mansfield, our community is perfect for healthcare professionals and patients seeking proximity to the hospital.\n\nOak Wood Apartments features spacious two- and three-bedroom units equipped with desirable amenities like controlled access and in-unit dishwashers. Our pet-friendly environment and on-site management team ensure a stress-free living experience. With the added benefits of nearby shopping and flexible online payments, Oak Wood Apartments is an excellent choice for those needing quick access to OhioHealth Mansfield Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OhioHealth Mansfield Hospital",
      "seo_description": "Explore Oak Wood Apartments near OhioHealth Mansfield Hospital. Offers convenience and comfort with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-near-lexington-community-park-mansfield-oh",
      "search_query": "apartments near Lexington Community Park Mansfield OH",
      "category": "Park",
      "h1_title": "Apartments Near Lexington Community Park",
      "h2_subtitle": "Find tranquility and convenience near Lexington Community Park. Oak Wood Apartments offers the perfect home in Mansfield, OH.",
      "page_copy": "Nestled in the vibrant community of Mansfield, OH, Oak Wood Apartments offers ideal living just moments from Lexington Community Park. Whether you enjoy outdoor activities or simply need a peaceful setting, our location provides easy access to this beautiful local park.\n\nFeaturing spacious two- and three-bedroom units, Oak Wood Apartments ensures comfort with amenities like a playground, controlled access, and flexible online payments. Our pet-friendly policies and dedicated on-site management team make us a preferred choice for families and individuals alike who appreciate the blend of nature and suburban living near Lexington Community Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lexington Community Park",
      "seo_description": "Live near Lexington Community Park in Mansfield, OH. Oak Wood Apartments offers spacious homes with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "oak-wood-apartments-close-to-gorman-nature-center",
      "search_query": "Oak Wood Apartments close to Gorman Nature Center",
      "category": "Park",
      "h1_title": "Oak Wood Apartments Near Gorman Nature Center",
      "h2_subtitle": "Embrace nature at Oak Wood Apartments, just minutes from Gorman Nature Center. Discover tranquility and convenience in Mansfield.",
      "page_copy": "Experience the beauty of nature right at your doorstep at Oak Wood Apartments, strategically located near Gorman Nature Center in Mansfield, OH. This prime location is perfect for nature enthusiasts and those who enjoy outdoor adventures.\n\nOur community offers spacious two- and three-bedroom layouts with top-notch amenities such as controlled access, a playground, and a pet-friendly environment. With on-site management and flexible rent options, Oak Wood Apartments not only provides comfort and convenience but also ensures you are minutes away from the serenity of Gorman Nature Center. It's the ideal choice for a harmonious blend of modern living and natural surroundings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oak Wood Apartments Near Gorman Nature Center",
      "seo_description": "Discover Oak Wood Apartments near Gorman Nature Center. Enjoy spacious living with modern amenities close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "kingwood-center-gardens-apartment-living",
      "search_query": "nearby Kingwood Center Gardens apartment living",
      "category": "Park",
      "h1_title": "Apartment Living Near Kingwood Center Gardens",
      "h2_subtitle": "Explore comfort and convenience with apartment living near Kingwood Center Gardens. Oak Wood Apartments brings you a serene lifestyle in Mansfield, OH.",
      "page_copy": "Discover apartment living near Kingwood Center Gardens at Oak Wood Apartments. Our vibrant community in Mansfield, OH offers a perfect blend of urban accessibility and picturesque garden views that nature lovers and scene admirers will appreciate.\n\nExperience our roomy two- and three-bedroom apartments that are pet-friendly and feature amenities like a dishwasher, controlled access, and a playground. With an efficient on-site management team and convenient online payment options, Oak Wood Apartments ensures a hassle-free living experience. Enjoy being part of a community that is a stone's throw away from the stunning Kingwood Center Gardens, making your home a delightful retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Kingwood Center Gardens",
      "seo_description": "Live near Kingwood Center Gardens at Oak Wood Apartments in Mansfield, OH. Enjoy spacious layouts and modern amenities in a beautiful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "oak-wood-proximity-to-north-lake-park",
      "search_query": "Oak Wood proximity to North Lake Park",
      "category": "Park",
      "h1_title": "Oak Wood Apartments Near North Lake Park",
      "h2_subtitle": "Discover the perfect home at Oak Wood Apartments, in close proximity to North Lake Park. Enjoy the best of Mansfield, OH living.",
      "page_copy": "Oak Wood Apartments offers a unique living experience near Mansfield's beautiful North Lake Park. Ideally located, residents enjoy swift access to the park's serene environment and recreational opportunities.\n\nChoose from our spacious two- and three-bedroom apartment layouts equipped with modern amenities, including a dishwasher and online payment options. Our pet-friendly community boasts a playground and a responsive on-site management team dedicated to enhancing your living experience. When you reside at Oak Wood Apartments, you are not just near North Lake Park; you're part of a welcoming community with nature at its doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oak Wood Apartments Near North Lake Park",
      "seo_description": "Enjoy life at Oak Wood Apartments, close to North Lake Park in Mansfield, OH. Spacious homes with easy park access and great amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "apartments-next-to-maple-lake-park-lexington",
      "search_query": "apartments next to Maple Lake Park Lexington",
      "category": "Park",
      "h1_title": "Apartments Next to Maple Lake Park in Lexington",
      "h2_subtitle": "Discover tranquil living in apartments next to Maple Lake Park. Oak Wood Apartments offers prime amenities with easy access to Lexington's finest.",
      "page_copy": "At Oak Wood Apartments, enjoy a peaceful and convenient lifestyle with proximity to Maple Lake Park in Lexington. Our location is perfect for those who appreciate the beauty of nature while still having access to modern comforts.\n\nOur spacious two- and three-bedroom apartments are pet-friendly and include essential amenities like a dishwasher, controlled access, and flexible online payments. With a dedicated on-site management team, our residents experience seamless living. At Oak Wood Apartments, not only do you get comfort and convenience, but you're also just steps away from the picturesque Maple Lake Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Maple Lake Park, Lexington",
      "seo_description": "Oak Wood Apartments in Lexington offers spacious living next to Maple Lake Park. Enjoy great amenities and a serene location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "south-park-accessible-apartments-in-mansfield",
      "search_query": "South Park accessible apartments in Mansfield",
      "category": "Park",
      "h1_title": "Accessible Apartments Near South Park, Mansfield",
      "h2_subtitle": "Find accessible apartment options near South Park in Mansfield, OH. At Oak Wood Apartments, enjoy comfort and convenience in every detail.",
      "page_copy": "Welcome to Oak Wood Apartments, where accessibility meets modern living near South Park in Mansfield, OH. Our community offers an ideal location for those who appreciate the tranquility and accessibility of outdoor spaces.\n\nSelect from our spacious, pet-friendly two- and three-bedroom apartments, designed with your comfort in mind. Enjoy convenient features like controlled access, a dishwasher, and the ability to make online payments. Our dedicated on-site management team ensures a smooth living experience, so you can focus on enjoying your time just moments away from the scenic beauty of South Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apartments by South Park, Mansfield",
      "seo_description": "Explore Oak Wood Apartments, offering accessible living near South Park in Mansfield, OH. Spacious layouts with modern amenities available now.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167361",
      "source": "custom",
      "page_item_url": "malabar-farm-state-park-area-rental-apartments",
      "search_query": "Malabar Farm State Park area rental apartments",
      "category": "Park",
      "h1_title": "Rental Apartments Near Malabar Farm State Park",
      "h2_subtitle": "Explore rental apartments in the Malabar Farm State Park area. Oak Wood Apartments offers spacious living with excellent amenities.",
      "page_copy": "Located conveniently near Malabar Farm State Park, Oak Wood Apartments provides an ideal living space for those who cherish nature and tranquility. Our rental apartments are perfect for families and individuals seeking peaceful surroundings with modern conveniences in the area.\n\nChoose from our spacious two- and three-bedroom options, all within a pet-friendly community featuring amenities like controlled access, dishwashers, and online payment facilities. Enjoy the welcoming environment fostered by our on-site management team and the beautiful backdrop of Malabar Farm State Park, making Oak Wood Apartments a haven for outdoor enthusiasts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and a parking lot in front.",
        "public_id": "019d63b9-4574-730a-ab18-359b3b0be162",
        "storage_key": "property/6767906449167361/019d63b9-4574-730a-ab18-359b3b0be162.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Apartments by Malabar Farm State Park",
      "seo_description": "Find spacious rental apartments near Malabar Farm State Park at Oak Wood Apartments. Enjoy modern amenities and a scenic location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6198"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680132559"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5098667"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WPQ7B6ND"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkJEL3pySVJKVzRTN2FtQ0R5VysySHc9PSIsInZhbHVlIjoiaUdzbTE0UjNxc3NzL28rczNoMkp0UT09IiwibWFjIjoiODE0MDY2NzExODE3N2E2ZTBjMDJjNzIyNWYxMDc3MDE5OTE5YTU4MmI2MjRmZjQ1ZTlmZDMyNjI0YWZkM2Y2MiJ9"
    }
  ],
  "custom_qb_id": "6198",
  "custom_repli_id": "11680132559",
  "custom_realpage_id": "5098667",
  "custom_google_gtm_id": "GTM-WPQ7B6ND",
  "custom_rollout_phase": "Phase 2",
  "custom_vibesites_theme": "Prestige",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkJEL3pySVJKVzRTN2FtQ0R5VysySHc9PSIsInZhbHVlIjoiaUdzbTE0UjNxc3NzL28rczNoMkp0UT09IiwibWFjIjoiODE0MDY2NzExODE3N2E2ZTBjMDJjNzIyNWYxMDc3MDE5OTE5YTU4MmI2MjRmZjQ1ZTlmZDMyNjI0YWZkM2Y2MiJ9",
  "custom_audioeye_site_id": "71feb17a-dd87-4861-a8da-065d8f4af1bc",
  "custom_audioeye_site_hash": "1b71da2d71a3956ef42f317c452b2326"
};

export const generatedAt = '2026-09-23T21:54:26.983Z';
